import moment from 'moment';
import get from 'lodash/get';

import Avatar from '@mui/material/Avatar';
import Typography from "@mui/material/Typography";
import Stack from '@mui/material/Stack';

import {formatProviderName} from '../../helpers/providers';
import './AppointmentSummary.scss';


const Row = ({children}) => {
  return (
    <Stack direction="row" gap='0.5rem' alignItems='center'>
      {children}
    </Stack>
  );
};

const AppointmentSummary = (
  {
    provider,
    sessionType,
    date,
    time,
    datetime,
    scheduleManually = false,
    booked = false,
  }
) => {
  let dateStr, dateTime;
  if (!provider) return <></>;
  if (!scheduleManually) {
    dateStr = date ? date.format('MM/DD/yyyy') : datetime.format('MM/DD/yyyy');
    dateTime = time ? moment(`${dateStr} ${time}`, 'MM/DD/yyyy h:mm a') : datetime;
  }
  console.log('AppointmentSummary', {provider, sessionType, scheduleManually, booked});
  return (
    <Stack
      direction='row'
      alignItems='flex-start'
      justifyContent='flex-start'
      gap='12px'
      marginTop='0 !important'
      flexWrap={{xs: 'wrap', xsm: 'nowrap'}}
      className="provider-summary"
    >
      <Avatar
        className="provider-summary__avatar"
        alt={`${provider.firstName} ${provider.lastName}`}
        src={provider.imgSrc || provider?.public_profile_img_url}
        variant="square"
      />
      {
        !sessionType &&
        <Stack justifyContent='center' alignItems='center' style={{height: '117px'}}>
          {
            booked
            ? <Typography variant='large' color='text.primary'>
              <strong>{formatProviderName(provider)}</strong> has received your message and
              will be in contact with you shortly to get you scheduled for your first session!
            </Typography>
            : <Typography variant='large' color='text.primary'>
              You are booking with <strong>{formatProviderName(provider)}</strong>!
            </Typography>
          }
        </Stack>
      }
      {sessionType && 
        <Stack
          direction='column'
          alignItems='flex-start'
          marginTop='0 !important'
          justifyContent={{xs: 'flex-start', xsm: 'space-between'}}
          gap={{xs: '10px', xsm: 'false'}}
          width='100%'
          height='100%'
        >
          {
            !scheduleManually && dateTime &&
            <Stack>
              <Typography variant='largeSemiBoldTight' color='text.primary'>
                {dateTime.format('dddd, MMMM DD')}
              </Typography>
              <Typography variant='normal' color='text.light'>
                {dateTime.format('h:mm a')} - {get(sessionType, 'duration_minutes')} minutes
              </Typography>
            </Stack>
        }
        {sessionType?.title ?
          <Row>
            <Typography variant='normal' color='text.light'>
              {get(sessionType, 'title')}
            </Typography>
          </Row>
          : null
        }
        <Row>
          {(sessionType?.title || !scheduleManually) &&
            <Typography variant='normal' color='text.light'>
              {formatProviderName(provider)}
            </Typography>
          }
        </Row>
        </Stack>
      }
    </Stack>
  );
};

export default AppointmentSummary;
